<template>
  <el-dropdown
    trigger="click"
    @command="handleCommand"
  >
    <el-button
      type="text"
      icon="el-icon-more"
      @click.stop
    />
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-can="'desadv.view'"
        command="view"
      >
        <i class="el-icon-view" /> Megtekintés
      </el-dropdown-item>
      <el-dropdown-item
        v-can="'desadv.delete'"
        command="delete"
        divided
      >
        <i class="el-icon-delete" /> Törlés
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  props: {
    desadv: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleCommand(command) {
      if (command === 'view') {
        this.$router.replace('/sales/desadvs/view/' + this.desadv.id);
      } else if (command === 'delete') {
        this.confirmDelete();
      }
    },
    confirmDelete() {
      this.$confirm('Biztosan törli ezt a DESADV szállítólevelet? A raklapok és tételeik is törlődnek.', 'Megerősítés', {
        confirmButtonText: 'Törlés',
        cancelButtonText: 'Mégse',
        type: 'warning',
      }).then(async () => {
        await this.$store.dispatch('desadv/delete', this.desadv.id);
        this.$store.dispatch('desadv/fetchAll');
      }).catch(() => {});
    },
  },
};
</script>
